import { RegionShared } from "@1games-ru/region-shared";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { setQuickSlots } from "@/domains/inventory/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetQuickSlots() {
  const dispatch = useAppDispatch();

  const getQuickSlots = useCallback(
    async (data: typeof RegionShared.Backend.Requests.GetQuickSlotsRequest) => {
      const response = await RpcMpProvider.callServer<
        typeof RegionShared.Backend.Requests.GetQuickSlotsRequest,
        typeof RegionShared.Backend.Responses.GetQuickSlotsResponse
      >(RegionShared.Backend.Events.Inventory.GetQuickSlots, data);

      if (response instanceof RpcMpProviderSuccessResponse) {
        const slots = new Array(6).fill(null);
        response.data.quickSlots.forEach((item) => {
          slots[item.slotNumber - 1] = item;
        });

        dispatch(setQuickSlots(slots));
      } else {
        toast.error(response.message);
        console.log({ response });
      }
    },
    [],
  );

  return {
    getQuickSlots,
  };
}
